import { DeliveryRecurrenceFrequencyEnum } from "../../../Common/Forms/enums/delivery-recurrence-frequency.enum";
import { ChartTimeIntervalsEnum } from "../../../Common/Reports/enums/chart-time-intervals.enum";

export interface BriefingTemplateConfig {
    // recurrence
    recurrenceType: DeliveryRecurrenceFrequencyEnum;
    recurrenceHour: number;
    frequencyValues: number[];
    subjectLocalization: string;
    execSummaryLocalization: string;

    // coverage charts
    primaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum,
    secondaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum
}

export const MonthlyConfig: BriefingTemplateConfig = {
    recurrenceType: DeliveryRecurrenceFrequencyEnum.monthly,
    recurrenceHour: 10,
    frequencyValues: [0],
    subjectLocalization: 'Briefing.onlineBriefing.template.monthly',
    execSummaryLocalization: 'Briefing.onlineBriefing.template.quarterly.executiveMonthlyReport',

    primaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum.DYNAMIC,
    secondaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum.MONTH
};

export const QuarterlyConfig: BriefingTemplateConfig = {

    recurrenceType: DeliveryRecurrenceFrequencyEnum.quarterly,
    recurrenceHour: 12,
    frequencyValues: [],
    subjectLocalization: 'Briefing.onlineBriefing.template.quarterly',
    execSummaryLocalization: 'Briefing.onlineBriefing.template.quarterly.executiveQuarterlyReport',

    primaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum.WEEK,
    secondaryCoverageOverTimeChartInterval: ChartTimeIntervalsEnum.QUARTER
};